export default __webpack_public_path__ + "static/media/20160305-p3.bc0e7295.pdf";